export const fontSizes = {
    MICRO: "10px",
    TINY: "12px",
    LITTLE: "13px",
    SMALL: "14px",
    STANDARD: "16px",
    MEDIUM: "19px",
    LARGE: "22px",
    LARGE_PLUS: "24px",
    SUPER: "30px",
    MOBILE_TITLE: "32px",
    GIANT: "35px",
    TITLE: "36px",
    MASSIVE: "44px",
    SUPER_MASSIVE: "48px",
};
